// extracted by mini-css-extract-plugin
export default {"main":"DataDealingBanner_main__BB3PP","blank":"DataDealingBanner_blank__UJ-9Z","banner_wrapper":"DataDealingBanner_banner_wrapper__LCHFy","banner":"DataDealingBanner_banner__7GEJT"};